module.exports = __webpack_public_path__ + "static/media/65.16670f43.png";